<template>
    <form
        class="flex flex-wrap border border-gray-200 rounded py-3 px-4"
        @submit.prevent="saveUser"
    >
        <div class="lg:w-1/2 md:w-full">
            <div class="flex p-8 flex-col mb-3">
                <div class="field w-full px-3 mb-3">
                    <JetLabel
                        class="w-full"
                        for="nama_lengkap"
                        value="Nama Lengkap"
                    />

                    <InputDataGrid
                        ref="pegawaiInputDataGrid"
                        :config="pegawaiInputDataGridConfig"
                        :error="form.errors.pegawai_id"
                        :disabled="form.id"
                        @getInputDataGrid="getInputDataGridPegawai"
                    />
                    <InputError
                        :message="form.errors.pegawai_id"
                        class="mt-2"
                    />
                </div>
            </div>
            <div class="flex p-8 flex-col mb-3">
                <div class="flex flex-wrap">
                    <div class="field w-full px-3 mb-3">
                        <JetLabel class="w-full" for="role" value="Role" />
                    </div>
                    <InputError :message="form.errors.roles" class="mt-2" />
                    <div
                        v-for="role in $page.props.role_list"
                        :key="role.id"
                        class="lg:w-1/8 md:w-1/4 pb-4"
                    >
                        <div class="w-full px-3 text-center">
                            <JetLabel :for="role.name" :value="role.name" />
                            <Checkbox
                                :id="'role_' + role.name"
                                v-model="form.roles[role.name]"
                                :binary="true"
                                @change="onRoleChange(role.name)"
                            />
                        </div>
                    </div>
                </div>
                <!-- Unit selection fields for roles that require units -->
                <div v-if="form.roles.oprpengadaan" class="field w-full px-3 mt-3">
                    <JetLabel class="w-full" for="unit_oprpengadaan" value="Unit untuk Operator Pengadaan" />
                    <!-- Hidden field to store the real value -->
                    <input type="hidden" v-model="form.unit_oprpengadaan" />
                    <!-- Select without v-model -->
                    <select
                        id="unit_oprpengadaan"
                        class="mt-1 block w-full border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm"
                        :class="{ 'border-red-500': form.errors.unit_oprpengadaan }"
                        @change="selectUnit($event, 'oprpengadaan')"
                    >
                        <option value="">Pilih Unit</option>
                        <option 
                            v-for="unit in $page.props.unit_list" 
                            :key="unit.id" 
                            :value="unit.id"
                        >
                            {{ unit.nama_unit }}
                        </option>
                    </select>
                    <InputError :message="form.errors.unit_oprpengadaan" class="mt-2" />
                    <div class="mt-1 text-xs text-gray-500">Value: {{ form.unit_oprpengadaan }}</div>
                </div>
                
                <div v-if="form.roles.verifikatorpa" class="field w-full px-3 mt-3">
                    <JetLabel class="w-full" for="unit_verifikatorpa" value="Unit untuk Verifikator PA" />
                    <!-- Hidden field to store the real value -->
                    <input type="hidden" v-model="form.unit_verifikatorpa" />
                    <!-- Select without v-model -->
                    <select
                        id="unit_verifikatorpa"
                        class="mt-1 block w-full border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm"
                        :class="{ 'border-red-500': form.errors.unit_verifikatorpa }"
                        @change="selectUnit($event, 'verifikatorpa')"
                    >
                        <option value="">Pilih Unit</option>
                        <option 
                            v-for="unit in $page.props.unit_list" 
                            :key="unit.id" 
                            :value="unit.id"
                        >
                            {{ unit.nama_unit }}
                        </option>
                    </select>
                    <InputError :message="form.errors.unit_verifikatorpa" class="mt-2" />
                    <div class="mt-1 text-xs text-gray-500">Value: {{ form.unit_verifikatorpa }}</div>
                </div>
            </div>
        </div>
        <div class="lg:w-1/2 md:w-full">
            <div class="flex p-8 flex-col mb-3">
                <div class="field w-full px-3 mb-3">
                    <JetLabel class="w-full" for="identity" value="Identity" />
                    <Input
                        id="identity"
                        v-model="form.identity"
                        type="text"
                        placeholder=""
                        class="mt-1 block w-full"
                        :class="{ 'p-invalid': form.errors.identity }"
                        readonly="readonly"
                    />
                    <InputError :message="form.errors.identity" class="mt-2" />
                </div>
                <div class="field w-full px-3 mb-3">
                    <JetLabel class="w-full" for="username" value="Username" />
                    <Input
                        id="username"
                        v-model="form.username"
                        type="text"
                        placeholder=""
                        class="mt-1 block w-full"
                        :class="{ 'p-invalid': form.errors.username }"
                        readonly="readonly"
                    />
                    <InputError :message="form.errors.username" class="mt-2" />
                </div>
                <div class="field w-full px-3 mb-3">
                    <Alert :msg="'Password default : q1w2e3r4'" />
                </div>
            </div>
        </div>
        <div class="lg:w-full md:w-full">
            <div class="flex flex-col mb-6">
                <div class="w-full px-3 text-center">
                    <InertiaButtonEdit
                        :class="{ 'opacity-25': form.processing }"
                        label="Simpan Data"
                        v-if="form.id"
                    />
                    <InertiaButtonSave
                        :class="{ 'opacity-25': form.processing }"
                        label="Simpan Baru"
                        v-else
                    />
                </div>
            </div>
        </div>
    </form>
</template>
<script>
import { defineComponent } from "vue";
import axios from "axios";
import Checkbox from "primevue/checkbox";
import ButtonSave from "@/Components/ButtonSave";
import JetLabel from "@/Jetstream/Label";
import Input from "@/Components/Input.vue";
import InputError from "@/Components/InputError.vue";
import InertiaButtonSave from "@/Components/InertiaButtonSave.vue";
import InertiaButtonEdit from "@/Components/InertiaButtonEdit.vue";
import Select from "@/Components/Select";
import Alert from "@/Components/Alert";

import InputDataGrid from "@/Components/InputDataGrid";

export default defineComponent({
    props: ["selectedData"],
    components: {
        Checkbox,
        ButtonSave,
        JetLabel,
        Input,
        InputError,
        InertiaButtonSave,
        InertiaButtonEdit,
        Select,
        Alert,
        InputDataGrid,
    },
    data() {
        return {
            pegawaiInputDataGridConfig: {
                table: "pegawai",
                formName: "nama_lengkap",
                defineCols: [
                    {
                        field: "nip",
                        header: "NIP",
                        style: "max-width: 15rem",
                    },
                    {
                        field: "nama_lengkap",
                        header: "Nama",
                        style: "max-width: 25rem",
                    },
                ],
                dtSourceApiRoute: {
                    list: "pegawai.data",
                },
            },
            form: this.$inertia.form({
                _method: "POST",
                id: null,
                pegawai_id: null,
                username: null,
                identity: null,
                roles: {},
                unit_id: null,
                unit_oprpengadaan: null,
                unit_verifikatorpa: null,
            }),
        };
    },
    mounted() {
        console.log("Unit list from props:", this.$page.props.unit_list);
        if (this.$page.props.unit_list) {
            console.log("First unit:", this.$page.props.unit_list[0]);
            console.log("Unit list length:", this.$page.props.unit_list.length);
        }
        this.preparedAvailRoles();
        this.checkOperatorPengadaanRole();
    },
    computed: {
        unitOptions() {
            if (!this.$page.props.unit_list) {
                return [];
            }

            console.log("Computing unit options from:", this.$page.props.unit_list);
            return this.$page.props.unit_list;
        },
        unitSelectionDebug() {
            console.log("Current unit selections - oprpengadaan:", this.form.unit_oprpengadaan, "verifikatorpa:", this.form.unit_verifikatorpa);
            return null;
        }
    },
    watch: {
        // whenever question changes, this function will run
        selectedData(newSelectedData, oldSelectedData) {
            this.resetForm();
        },
        'form.roles': {
            handler() {
                this.checkOperatorPengadaanRole();
            },
            deep: true
        }
    },
    methods: {
        prepareFormRolesData: function () {
            let role_data = [];
            let role_list = this.$page.props.role_list;
            let self = this;
            _.forEach(role_list, function (role) {
                if (self.form.roles[role.name]) {
                    role_data.push({ name: role.name });
                }
            });
            return role_data;
        },
        preparedAvailRoles: function (selected_roles = []) {
            let role_list = this.$page.props.role_list;
            let self = this;
            _.forEach(role_list, function (role) {
                self.form.roles[role.name] = false;
            });

            _.forEach(selected_roles, function (selected_role) {
                if (_.has(self.form.roles, selected_role.name)) {
                    self.form.roles[selected_role.name] = true;
                }
            });
        },
        addItem: function () {
            //
        },
        getInputDataGridPegawai: function (inputData) {
            console.log(inputData);
            this.form.pegawai_id = inputData.id;
            this.form.identity = inputData.nip;
            this.form.username = inputData.nip;
        },
        populateEdit: function (user) {
            console.log("Populating user data:", user);
            this.form.id = user.id;
            this.form.pegawai_id = user.pegawai_id;
            this.form.nama_lengkap = user.pegawai.nama_lengkap;
            this.form.username = user.username;
            this.form.identity = user.identity;
            this.form.unit_id = user.unit_id;
            
            // Extract unit IDs for specific roles
            if (user.roles && user.roles.length > 0) {
                console.log("User roles:", user.roles);
                
                // Look for the oprpengadaan role
                const oprpengadaanRole = user.roles.find(role => role.name === 'oprpengadaan');
                console.log("Found oprpengadaan role:", oprpengadaanRole);
                
                if (oprpengadaanRole && oprpengadaanRole.pivot && oprpengadaanRole.pivot.unit_id) {
                    // Convert to string to ensure type match
                    this.form.unit_oprpengadaan = String(oprpengadaanRole.pivot.unit_id);
                    console.log('Set oprpengadaan unit to:', this.form.unit_oprpengadaan);
                }
                
                // Look for the verifikatorpa role
                const verifikatorpaRole = user.roles.find(role => role.name === 'verifikatorpa');
                console.log("Found verifikatorpa role:", verifikatorpaRole);
                
                if (verifikatorpaRole && verifikatorpaRole.pivot && verifikatorpaRole.pivot.unit_id) {
                    // Convert to string to ensure type match
                    this.form.unit_verifikatorpa = String(verifikatorpaRole.pivot.unit_id);
                    console.log('Set verifikatorpa unit to:', this.form.unit_verifikatorpa);
                }
            }
            
            this.preparedAvailRoles(user.roles);
            this.$refs.pegawaiInputDataGrid.setData(user);
            
            // Force Vue to update the select values after a delay
            setTimeout(() => {
                this.initializeSelectValues();
            }, 200);
        },
        // New method to initialize select values
        initializeSelectValues() {
            // Set the oprpengadaan select value if needed
            if (this.form.unit_oprpengadaan && this.form.roles.oprpengadaan) {
                const select = document.getElementById('unit_oprpengadaan');
                if (select) {
                    select.value = this.form.unit_oprpengadaan;
                    console.log(`Initialized oprpengadaan select to: ${this.form.unit_oprpengadaan}`);
                }
            }
            
            // Set the verifikatorpa select value if needed
            if (this.form.unit_verifikatorpa && this.form.roles.verifikatorpa) {
                const select = document.getElementById('unit_verifikatorpa');
                if (select) {
                    select.value = this.form.unit_verifikatorpa;
                    console.log(`Initialized verifikatorpa select to: ${this.form.unit_verifikatorpa}`);
                }
            }
        },
        selectUnit(event, type) {
            // Update the form value when select changes
            this.form[`unit_${type}`] = event.target.value;
            console.log(`${type} unit selected:`, event.target.value);
        },
        resetForm: function (event) {
            this.form.id = null;
            this.form.pegawai_id = null;
            this.form.username = null;
            this.form.identity = null;
            this.form.unit_id = null;
            this.form.unit_oprpengadaan = null;
            this.form.unit_verifikatorpa = null;
            this.preparedAvailRoles();
            // this.form.reset();
            this.$refs.pegawaiInputDataGrid.clear();
            this.form.clearErrors();
        },
        saveUser: function (event) {
            // Validate unit selections for roles that require them
            let hasErrors = false;
            
            if (this.form.roles.oprpengadaan && !this.form.unit_oprpengadaan) {
                this.form.setError('unit_oprpengadaan', 'Unit harus dipilih untuk Operator Pengadaan');
                hasErrors = true;
            }
            
            if (this.form.roles.verifikatorpa && !this.form.unit_verifikatorpa) {
                this.form.setError('unit_verifikatorpa', 'Unit harus dipilih untuk Verifikator PA');
                hasErrors = true;
            }
            
            if (hasErrors) {
                return;
            }
            
            // For backward compatibility, set the main unit_id
            if (this.form.unit_oprpengadaan) {
                this.form.unit_id = this.form.unit_oprpengadaan;
            } else if (this.form.unit_verifikatorpa) {
                this.form.unit_id = this.form.unit_verifikatorpa;
            }

            let self = this;
            console.log('Sending form data to server:', this.form.data());
            
            // Use AJAX route for better UX
            const routeToUse = route("user.store2.ajax");
            console.log('Using AJAX route:', routeToUse);
            
            // Use axios for AJAX request
            axios.post(routeToUse, this.form.data())
                .then((response) => {
                    console.log('✅ Success response:', response.data);
                    
                    // Show success toast
                    if (response.data.success) {
                        self.$toast.add({
                            severity: 'success',
                            summary: 'Berhasil!',
                            detail: response.data.message,
                            life: 3000
                        });
                        
                        // Refresh data table
                        let form = Object.assign({}, self.form);
                        form.roles = self.prepareFormRolesData();
                        if (form.id) {
                            self.$emit("changeData", form);
                        } else {
                            self.$emit("loadData");
                            self.resetForm();
                        }
                    }
                })
                .catch((error) => {
                    console.log('❌ Error response:', error.response?.data);
                    
                    // Show error toast
                    self.$toast.add({
                        severity: 'error',
                        summary: 'Error!',
                        detail: error.response?.data?.message || 'Terjadi kesalahan saat menyimpan data',
                        life: 5000
                    });
                    
                    // Handle validation errors
                    if (error.response?.data?.errors) {
                        Object.keys(error.response.data.errors).forEach(field => {
                            self.form.setError(field, error.response.data.errors[field][0]);
                        });
                    }
                })
                .finally(() => {
                    console.log('🏁 AJAX request finished');
                });
        },
        checkOperatorPengadaanRole() {
            // No need for additional checks here
        },
        onRoleChange(roleName) {
            // No need for additional checks here
        },
    },
});
</script>
